import {
  ErrorDialogComponent,
  ErrorDialogData,
} from '@/components/error-dialog/error-dialog.component';
import { LoadingService } from '@/services/loading.service';
import { NotificationService } from '@/services/notification.service';
import { SessionService } from '@/services/session.service';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class ErrorHandler implements HttpInterceptor {
  constructor(
    protected dialog: MatDialog,
    protected sessionService: SessionService,
    protected loadingService: LoadingService,
    private notificationService: NotificationService,
    private router: Router
  ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err) => {
        let mensagem = '';
        let titulo = 'Um erro aconteceu';
        if (err.status === 401) {
          this.sessionService.logout();
        }

        if(err.status === 403){
          this.notificationService.showErrorMessages(["Usuário sem acesso a requisição."])
          this.loadingService.hide();
          //this.router.navigate(["/home"]);
        }

        // TODO: Verificar mensagens de erros
        if (err.status === 400 && err.error.messages[0] !== '') {
          console.error('An error occurred:', err.error.messages);

          if (Array.isArray(err.error.messages)) {
            this.notificationService.showErrorMessages(err.error.messages);
            this.loadingService.hide();
          }
        }

        if (err.status === 500) {
          console.error('An error occurred:', err.error.Message);
          mensagem = err.errors.Message;
          this.geraModalDeErro(titulo, mensagem);
          this.loadingService.hide();
        }

        if (err.error instanceof ErrorEvent) {
          console.error('An error occurred:', err.error.Message);
          mensagem = err.error.Message;
          this.geraModalDeErro(titulo, mensagem);
          this.loadingService.hide();
        }

        const error = err.error || err.statusText;
        return throwError(error);
      }),
    );
  }

  private geraModalDeErro(titulo: string, mensagem: string): void {
    const dialogData: ErrorDialogData = {
      title: titulo,
      text: `<div class="dialog-error-message">${mensagem}</div>`,
      textButton: 'Fechar',
      typeButton: '',
      iconButton: '',
      showCancel: false,
    };

    this.dialog.open(ErrorDialogComponent, {
      width: '500px',
      data: dialogData,
    });

    this.loadingService.hide();
  }
}
